module.exports = __webpack_public_path__ + "html/juhu-auto.template.html";